import { render, staticRenderFns } from "./print2Group.vue?vue&type=template&id=012e64ef"
import script from "./print2Group.vue?vue&type=script&lang=js"
export * from "./print2Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports